import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!

  return (_openBlock(), _createBlock(_component_FilterableDropdown, {
    modelValue: _ctx.modelValue,
    textLabel: _ctx.textLabel,
    placeholder: _ctx.placeholder,
    options: _ctx.returnLocationOptions,
    customLabel: _ctx.getLocationDisplayName,
    size: _ctx.size,
    "onUpdate:modelValue": _ctx.updateReturnLocation,
    onSearchChange: _ctx.searchCustomers
  }, null, 8, ["modelValue", "textLabel", "placeholder", "options", "customLabel", "size", "onUpdate:modelValue", "onSearchChange"]))
}